import { flow, slice, map, pick } from 'lodash/fp';
import {
  FlightInfo,
  getPackagesActualizeResponse,
  GetPackagesShowResponse,
  PackageDepartureHotelImage,
} from '@lt/api/dist/methods/packages/types';
import { PackageContextState, PackagePreloadedState } from '../types';
import { createWidgetLink } from '../../../utils/url/index';

export const pickKeysFromPackage = (
  packageData: GetPackagesShowResponse
): PackageContextState['package'] => ({
  ...pick(
    [
      'id',
      'labels',
      'hotel',
      'manual',
      'archived_at',
      'dates_info',
      'adults_count',
      'kids_ages',
      'kids_count',
      'search_type',
      'price',
      'net_price',
      'previous_price',
      'instant_confirm',
      'medical_insurance',
      'transfer',
      'pansion_description',
      'pansion',
      'pansion_original',
    ],
    packageData
  ),
  room_info: {
    name_ru: packageData.room_info?.name_ru,
    images: flow(slice(0, 1), map(pick(['x100x110', 'id'])))(packageData.room_info?.images),
  },
});

export const getMoreFlightsOptionsCount = (
  actualizationData: getPackagesActualizeResponse
): number => {
  if (!actualizationData || actualizationData.flight_options.length < 2) {
    return 0;
  }
  return actualizationData.flight_options.length - 1;
};

export const getFirstFlight = (
  actualizationData?: getPackagesActualizeResponse
): FlightInfo | undefined => {
  if (!actualizationData || !actualizationData.flight_options.length) {
    return undefined;
  }

  return actualizationData.flight_options[0];
};

export const sliceHotelImage = (
  hotelImages: Partial<PackageDepartureHotelImage>[]
): Partial<PackageDepartureHotelImage>[] => {
  return flow(slice(0, 7), map(pick(['x900', 'id'])))(hotelImages);
};

export const createQSForLinkToPackage = ({
  search_type,
  baseQueryParams,
}: {
  search_type: string;
  baseQueryParams?: Record<string, string>;
}): Record<string, string> => {
  return Object.assign(
    {
      search_type,
    },
    baseQueryParams
  );
};

export const createLinkToPackage = (
  domain: string,
  packageId: number,
  qs?: Record<string, string | number | boolean>
): string => {
  const link = createWidgetLink(`${domain}/packages/${packageId}/copy`, qs);
  return link;
};

export const mapPackageToPackageContextState = (
  packageData: GetPackagesShowResponse,
  actualizationData: PackagePreloadedState
): PackageContextState => {
  const shortPackageData = pickKeysFromPackage(packageData);

  return {
    ...actualizationData,
    package_id: shortPackageData.id,
    package: {
      ...shortPackageData,
      hotel: {
        ...shortPackageData.hotel,
        images: sliceHotelImage(shortPackageData.hotel.images),
      },
      room_info: {
        ...shortPackageData.room_info,
      },
    },
  };
};
